export interface DisclosureFee {
  actual_amount: string;
  cd_section: string;
  contact_id: number;
  created_at: string;
  deleted_at: string;
  description: string;
  estimated_amount: string;
  final_le_amount: number;
  id: number;
  included_in_apr: boolean;
  le_section: string;
  loan_application_id: number;
  mismo_type: string;
  paid_before_closing: boolean;
  paid_by_type: string;
  paid_to_type: string;
  recipient: string;
  root_id: string;
  source: string;
  tolerance: string;
  unsaved: boolean;
  valid: boolean;
}

// Stored in localStorage, for differentiating fee types - take caution in modifying
export enum DisclosureType {
  LoanEstimate = "Loan Estimate",
  ClosingDisclosure = "Closing Disclosure",
}

export const DisclosureTypeRecord: Record<DisclosureType, string> = {
  [DisclosureType.LoanEstimate]: "LE",
  [DisclosureType.ClosingDisclosure]: "CD",
};

// For use in ContentSwitcher's Switches
export const DISCLOSURE_TYPE_SWITCH_OPTIONS = [
  {
    text: "Loan Estimate",
    name: DisclosureType.LoanEstimate,
  },
  {
    text: "Closing Disclosure",
    name: DisclosureType.ClosingDisclosure,
  },
];
